import {
  GET_DUGOUT_CONTRACT_INSURANCE_ENTITIES_QUERY_KEY,
  GET_DUGOUT_CONTRACT_VERSION_HISTORY_QUERY_KEY,
  GET_DUGOUT_CONTRACTS_QUERY_KEY
} from '@/constants/contracts';
import useAPI from '@/hooks/useAPI';
import DugoutContractRepository from '@/repositories/DugoutContractRepository';
import type { QueryParams } from '@/types/query';

export const useDugoutContracts = (params: QueryParams) => {
  const repository = DugoutContractRepository();

  return useAPI({
    queryKey: [GET_DUGOUT_CONTRACTS_QUERY_KEY, params],
    queryFn: async () => await repository.list(params),
    keepPreviousData: true
  });
};

export const useDugoutContractInsuranceEntities = (contractId: string) => {
  const repository = DugoutContractRepository();

  return useAPI({
    queryKey: [GET_DUGOUT_CONTRACT_INSURANCE_ENTITIES_QUERY_KEY, contractId],
    queryFn: async () => await repository.insuranceEntities(contractId),
    staleTime: 5 * 60 * 1000
  });
};

export const useDugoutContractDetail = (contractId: string) => {
  const repository = DugoutContractRepository();
  return useAPI({
    queryKey: ['dugoutContractDetail', contractId],
    queryFn: async () => await repository.detail(contractId),
    enabled: !!contractId,
    // Switching versions keeps the current one on screen until the next arrives.
    keepPreviousData: true
  });
};

export const useDugoutContractVersionHistory = (contractId: string) => {
  const repository = DugoutContractRepository();
  return useAPI({
    queryKey: [GET_DUGOUT_CONTRACT_VERSION_HISTORY_QUERY_KEY, contractId],
    queryFn: async () => await repository.versionHistory(contractId),
    enabled: !!contractId
  });
};
